import { Section, Chapter, Reveal } from "./Section";
import LeadForm from "./LeadForm";
import { Network, Gift, Users, TrendingUp } from "lucide-react";

const OFFERS = [
  [Network, "Administrative support for ministries & organizations"],
  [Gift, "Gift development & ministry fellowship"],
  [Users, "Leadership development at every level"],
  [TrendingUp, "Connections that help gifts reach further"],
];

export default function Associates() {
  return (
    <Section id="associates" testid="associates-section" className="bg-white/[0.015]">
      <div className="grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <span data-testid="associates-badge" className="inline-flex items-center gap-2.5 mb-6 border border-amber-400/40 bg-amber-400/10 text-amber-200 px-4 py-2 rounded-full text-sm font-semibold font-mono uppercase tracking-widest">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400 animate-pulse-dot" />
            A New Chapter Begins in 2026
          </span>
          <Chapter number="04" label="The Kingdom Associates" testid="associates-chapter"
            title={<>Equipping the Called.<br /><span className="text-vg">Connecting the Kingdom.</span></>}
            sub="For more than 15 years, The Kingdom Associates has equipped ministers, gospel artists, ministry leaders, churches, and Kingdom organizations — now expanding beyond national affiliations toward global Kingdom unification." />

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {OFFERS.map(([Icon, text], i) => (
              <Reveal key={text} delay={0.06 * i} className="flex items-center gap-3 text-base font-medium text-slate-200">
                <Icon size={18} className="shrink-0 text-amber-400" />
                <span>{text}</span>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <p className="mt-8 font-display text-2xl sm:text-3xl font-extrabold text-vg">Kingdom Business for the Kingdom Minded.</p>
          </Reveal>

          <Reveal delay={0.2} className="mt-8 glow-frame">
            <div className="rounded-[1.7rem] bg-[#0B0E16] p-7">
              <p className="mb-6 font-mono text-sm font-semibold uppercase tracking-[0.25em] text-vg">Become an Associate</p>
              <LeadForm type="associate" idPrefix="associates" extra={["organization", "message"]} submitLabel="Become an Associate" />
            </div>
          </Reveal>
        </div>

        <Reveal className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative group">
            <div aria-hidden className="absolute -inset-4 rounded-[2rem] bg-amber-500/15 blur-2xl group-hover:bg-amber-500/25 transition-all duration-500" />
            <div className="relative overflow-hidden rounded-[1.75rem] border border-amber-400/25 shadow-[0_0_60px_rgba(245,158,11,0.15)] transition-transform duration-700 group-hover:scale-[1.02]">
              <img src="/assets/kingdom-associates.webp" alt="Kingdom Associates — Kingdom Business for the Kingdom Minded"
                data-testid="associates-artwork" className="w-full object-cover" />
            </div>
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
